import { render, staticRenderFns } from "./ListFile.vue?vue&type=template&id=3974445b"
import script from "./ListFile.vue?vue&type=script&lang=js"
export * from "./ListFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3974445b')) {
      api.createRecord('3974445b', component.options)
    } else {
      api.reload('3974445b', component.options)
    }
    module.hot.accept("./ListFile.vue?vue&type=template&id=3974445b", function () {
      api.rerender('3974445b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Folder/ListFile.vue"
export default component.exports